import { reset, set, setValue } from '../../../utils/vuex'
import getDefaultState from './defaultState'
const defaultState = getDefaultState()

export default {
  setOrder: set('order'),
  clearOrder: setValue('order', null),
  reset: reset(defaultState)
}
